
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c6u22", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");




const $e77954c2fac8bb43$var$RecursiveExcerptContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    hasKey: ()=>false,
    addKey: ()=>{},
    removeKey: ()=>{},
    isProviderAvailable: false
});
const $e77954c2fac8bb43$export$8fbc0efd03a015e = ({ children: children, excerptKey: excerptKey })=>{
    const keys = (0, $cozmU.useMemo)(()=>{
        return new Set();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (excerptKey) keys.add(excerptKey);
    }, [
        keys,
        excerptKey
    ]);
    const hasKey = (0, $cozmU.useCallback)((key)=>{
        return keys.has(key);
    }, [
        keys
    ]);
    const addKey = (0, $cozmU.useCallback)((key_0)=>{
        keys.add(key_0);
    }, [
        keys
    ]);
    const removeKey = (0, $cozmU.useCallback)((key_1)=>{
        keys.delete(key_1);
    }, [
        keys
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        return {
            hasKey: hasKey,
            addKey: addKey,
            removeKey: removeKey,
            isProviderAvailable: true
        };
    }, [
        hasKey,
        addKey,
        removeKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e77954c2fac8bb43$var$RecursiveExcerptContext.Provider, {
        value: contextValue
    }, children);
};
const $e77954c2fac8bb43$export$3f68eeb1746e8c90 = ()=>{
    return (0, $cozmU.useContext)($e77954c2fac8bb43$var$RecursiveExcerptContext);
};









var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");

const $0f05f8ec17df934b$var$i18n = (0, $kSwu1.defineMessages)({
    errorDescription: {
        id: "excerpt-include.recursive-error.description",
        defaultMessage: "This insert excerpt macro cannot insert an excerpt that it is nested within."
    }
});
const $0f05f8ec17df934b$export$6990faa355fa7d3 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($0f05f8ec17df934b$var$i18n.errorDescription);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, t0));
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};









var $422HI = parcelRequire("422HI");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");


var $1P7Cq = parcelRequire("1P7Cq");


var $9wGTI = parcelRequire("9wGTI");








var $hekY6 = parcelRequire("hekY6");





var $gC2EJ = parcelRequire("gC2EJ");


var $kksmx = parcelRequire("kksmx");


var $5LTS4 = parcelRequire("5LTS4");





var $bX5uj = parcelRequire("bX5uj");


var $6mKj3 = parcelRequire("6mKj3");


var $dhEYL = parcelRequire("dhEYL");




const $586bbeb50503c018$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    emptyMacro: {
        id: "excerpt-include.empty",
        defaultMessage: "No excerpts found."
    },
    emptyMacroEdit: {
        id: "excerpt-include.empty.edit",
        defaultMessage: "Select{editIcon}to choose a different source page."
    },
    untitledExcerpt: {
        id: "excerpt-include.untitled",
        defaultMessage: "Untitled excerpt"
    }
});


const $5942172932878591$var$akEditorDefaultLayoutWidth = 760;
const $5942172932878591$var$styles = {
    excerptInclude: "_4ouGXIdnbC",
    inlineExcerptInclude: "_313842FQfX",
    extensionExcerptBody: "_3iDTPbvLZJ _1EqgXlN91d",
    emptyContent: "_4FKVYE1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzZpcK",
    fullWidthExtensionWrapper: "_39xV028yGE"
}; // Bodied macros (e.g. Page Properties) render via the platform extension renderer, which sizes the
// body from its measured container width — that collapses to ~2px inside the inline excerpt-include
// wrapper. Plain content (tables, lists, paragraphs) renders fine and is intentionally excluded.
const $5942172932878591$var$COLLAPSING_EXTENSION_NODE_TYPES = new Set([
    'bodiedExtension',
    'multiBodiedExtension'
]); // The legacy-content migration macro is the only thing that carries nestedContent, and the only way
// a bodied macro ends up inside an excerpt (migrated content).
const $5942172932878591$var$LEGACY_CONTENT_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $5942172932878591$var$LEGACY_CONTENT_EXTENSION_KEY = 'legacy-content';
const $5942172932878591$var$isBodiedExtension = (node)=>typeof node?.type === 'string' && $5942172932878591$var$COLLAPSING_EXTENSION_NODE_TYPES.has(node.type);
const $5942172932878591$var$isLegacyContentExtension = (node)=>node?.attrs?.extensionType === $5942172932878591$var$LEGACY_CONTENT_EXTENSION_TYPE && node?.attrs?.extensionKey === $5942172932878591$var$LEGACY_CONTENT_EXTENSION_KEY;
const $5942172932878591$var$excerptContentContainsExtension = (adf, includeBlockExtensions = false)=>{
    if (!adf) return false;
     // Normalise both payload shapes: a content array (macroOutput) or a full `doc` node (resolver).
    let nodes;
    if (Array.isArray(adf)) nodes = adf;
    else if (adf.type === 'doc' && Array.isArray(adf.content)) nodes = adf.content;
    else nodes = [
        adf
    ];
     // Unwrapped bodied macro (view path: macroOutput is already unwrapped).
    const needsContainerWidth = (node)=>$5942172932878591$var$isBodiedExtension(node) || includeBlockExtensions && node.type === 'extension';
    if (nodes.some(needsContainerWidth)) return true;
     // Bodied macro still wrapped by the legacy-content migration macro (edit path): look one level
    // into the nestedContent of any legacy-content extension.
    const nestedNodes = nodes.flatMap((node)=>$5942172932878591$var$isLegacyContentExtension(node) ? node.attrs?.parameters?.nestedContent?.content ?? [] : []);
    return nestedNodes.some(needsContainerWidth);
};
const $5942172932878591$export$1980ed6e948b49ee = (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { adf: adf, contentId: contentId, pageId: pageId, shouldPanelBeDisplayed: shouldPanelBeDisplayed, excerptName: excerptName, targetContentTitle: targetContentTitle, mode: mode, extensionKey: extensionKey, macroNode: macroNode, macroId: macroId, RendererWrapper: RendererWrapper, isLegacyRenderer: isLegacyRenderer, mediaToken: mediaToken, isLivePage: isLivePage, renderServerPlaceholder: renderServerPlaceholder } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== macroNode) {
        t1 = (0, $5kjCz.getMacroAttributesFromADFNode)(macroNode);
        $[0] = macroNode;
        $[1] = t1;
    } else t1 = $[1];
    const attributes = t1;
    let t2;
    if ($[2] !== RendererWrapper || $[3] !== adf || $[4] !== attributes || $[5] !== contentId || $[6] !== excerptName || $[7] !== extensionKey || $[8] !== intl || $[9] !== isLegacyRenderer || $[10] !== isLivePage || $[11] !== macroId || $[12] !== macroNode || $[13] !== mediaToken || $[14] !== mode || $[15] !== pageId || $[16] !== renderServerPlaceholder || $[17] !== shouldPanelBeDisplayed || $[18] !== targetContentTitle) {
        const useBlockExtensionWidth = !shouldPanelBeDisplayed && $5942172932878591$var$excerptContentContainsExtension(adf, true) && (0, $6mKj3.expValEquals)("cc_excerpt_nested_renderer_cls", "isEnabled", true);
        let t3;
        if ($[20] !== adf || $[21] !== excerptName) {
            t3 = ()=>{
                const emptyAdf = [
                    {
                        type: "paragraph"
                    }
                ];
                return !!adf && (!!excerptName || JSON.stringify(adf) !== JSON.stringify(emptyAdf));
            };
            $[20] = adf;
            $[21] = excerptName;
            $[22] = t3;
        } else t3 = $[22];
        const hasExcerpt = t3;
        const getExcerptBody = ()=>{
            if (!hasExcerpt()) return /*#__PURE__*/ $cozmU.createElement($5942172932878591$var$ExcerptIncludeEmpty, {
                mode: mode,
                shouldPanelBeDisplayed: shouldPanelBeDisplayed,
                isLivePage: isLivePage
            });
            const forceFullWidthExtension = useBlockExtensionWidth || !shouldPanelBeDisplayed && $5942172932878591$var$excerptContentContainsExtension(adf) && (0, $6mKj3.expValEquals)("confluence_frontend_fix_excerpt_include_width", "isEnabled", true);
            const excerptRenderer = /*#__PURE__*/ $cozmU.createElement(RendererWrapper, {
                adf: adf,
                targetContentId: contentId,
                mediaToken: mediaToken,
                isInsideOfInlineExtension: forceFullWidthExtension ? false : !shouldPanelBeDisplayed,
                headingIdPrefix: (0, $6mKj3.expValEquals)("confluence_toc_included_content_exp", "isEnabled", true) ? macroId : undefined
            });
            if (forceFullWidthExtension) return /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $5942172932878591$var$styles.extensionExcerptBody,
                    $5942172932878591$var$styles.fullWidthExtensionWrapper
                ])
            }, excerptRenderer);
            return excerptRenderer;
        };
        let t4;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = (0, $hekY6.default)([
                $5942172932878591$var$styles.excerptInclude,
                "ak-excerpt-include ak-renderer-extension"
            ]);
            $[23] = t4;
        } else t4 = $[23];
        let t5;
        if ($[24] !== macroId || $[25] !== renderServerPlaceholder) {
            t5 = renderServerPlaceholder ? {
                "data-ssr-placeholder": macroId
            } : {
                "data-ssr-placeholder-replace": macroId
            };
            $[24] = macroId;
            $[25] = renderServerPlaceholder;
            $[26] = t5;
        } else t5 = $[26];
        let t6;
        if ($[27] !== extensionKey || $[28] !== isLegacyRenderer || $[29] !== macroNode || $[30] !== pageId) {
            t6 = isLegacyRenderer && /*#__PURE__*/ $cozmU.createElement((0, $5LTS4.ExtensionLoadingComplete), {
                contentId: pageId,
                extensionKey: extensionKey,
                node: macroNode
            });
            $[27] = extensionKey;
            $[28] = isLegacyRenderer;
            $[29] = macroNode;
            $[30] = pageId;
            $[31] = t6;
        } else t6 = $[31];
        let t7;
        if ($[32] !== excerptName || $[33] !== getExcerptBody || $[34] !== hasExcerpt || $[35] !== intl || $[36] !== shouldPanelBeDisplayed || $[37] !== targetContentTitle) {
            t7 = shouldPanelBeDisplayed ? /*#__PURE__*/ $cozmU.createElement("span", {
                style: (0, $dhEYL.panel)
            }, /*#__PURE__*/ $cozmU.createElement("span", {
                style: (0, $dhEYL.panelHeader)
            }, targetContentTitle, hasExcerpt() && /*#__PURE__*/ $cozmU.createElement("span", {
                style: (0, $dhEYL.panelHeaderExcerpt)
            }, "| ", excerptName ?? intl.formatMessage((0, $586bbeb50503c018$export$a7357cdd1f0b0168).untitledExcerpt))), /*#__PURE__*/ $cozmU.createElement("span", {
                style: (0, $dhEYL.panelBody)
            }, getExcerptBody())) : getExcerptBody();
            $[32] = excerptName;
            $[33] = getExcerptBody;
            $[34] = hasExcerpt;
            $[35] = intl;
            $[36] = shouldPanelBeDisplayed;
            $[37] = targetContentTitle;
            $[38] = t7;
        } else t7 = $[38];
        let t8;
        if ($[39] !== macroId) {
            t8 = /*#__PURE__*/ $cozmU.createElement((0, $kksmx.ExtensionSSRMark), {
                macroId: macroId,
                renderType: "ssr-new"
            });
            $[39] = macroId;
            $[40] = t8;
        } else t8 = $[40];
        let t9;
        if ($[41] !== macroNode || $[42] !== mode) {
            t9 = (0, $5kjCz.getExperienceName)(mode, macroNode);
            $[41] = macroNode;
            $[42] = mode;
            $[43] = t9;
        } else t9 = $[43];
        let t10;
        if ($[44] !== attributes || $[45] !== extensionKey || $[46] !== mode || $[47] !== pageId || $[48] !== t9) {
            t10 = /*#__PURE__*/ $cozmU.createElement((0, $bX5uj.MacroExperienceSuccess), {
                contentId: pageId,
                extensionKey: extensionKey,
                mode: mode,
                attributes: attributes,
                name: t9
            });
            $[44] = attributes;
            $[45] = extensionKey;
            $[46] = mode;
            $[47] = pageId;
            $[48] = t9;
            $[49] = t10;
        } else t10 = $[49];
        let t11;
        if ($[50] !== macroId || $[51] !== t10 || $[52] !== t5 || $[53] !== t6 || $[54] !== t7 || $[55] !== t8) {
            t11 = /*#__PURE__*/ $cozmU.createElement("div", {
                "data-fabric-macro": macroId,
                className: t4,
                "data-testid": "excerpt-include-component",
                ...t5
            }, t6, t7, t8, t10);
            $[50] = macroId;
            $[51] = t10;
            $[52] = t5;
            $[53] = t6;
            $[54] = t7;
            $[55] = t8;
            $[56] = t11;
        } else t11 = $[56];
        const excerptIncludeComponent = t11;
        t2 = !shouldPanelBeDisplayed ? /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "inline-excerpt-include-component",
            className: (0, $hekY6.default)([
                $5942172932878591$var$styles.inlineExcerptInclude,
                useBlockExtensionWidth && $5942172932878591$var$styles.extensionExcerptBody,
                useBlockExtensionWidth && $5942172932878591$var$styles.fullWidthExtensionWrapper
            ])
        }, excerptIncludeComponent) : excerptIncludeComponent;
        $[2] = RendererWrapper;
        $[3] = adf;
        $[4] = attributes;
        $[5] = contentId;
        $[6] = excerptName;
        $[7] = extensionKey;
        $[8] = intl;
        $[9] = isLegacyRenderer;
        $[10] = isLivePage;
        $[11] = macroId;
        $[12] = macroNode;
        $[13] = mediaToken;
        $[14] = mode;
        $[15] = pageId;
        $[16] = renderServerPlaceholder;
        $[17] = shouldPanelBeDisplayed;
        $[18] = targetContentTitle;
        $[19] = t2;
    } else t2 = $[19];
    return t2;
};
const $5942172932878591$var$ExcerptIncludeEmpty = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { mode: mode, shouldPanelBeDisplayed: shouldPanelBeDisplayed, isLivePage: isLivePage } = t0;
    const intl = (0, $kSwu1.useIntl)();
    if (!shouldPanelBeDisplayed && !(mode === "editor" && !isLivePage)) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $5942172932878591$var$styles.emptyContent
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== intl) {
        t2 = intl.formatMessage((0, $586bbeb50503c018$export$a7357cdd1f0b0168).emptyMacro);
        $[1] = intl;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== intl || $[4] !== isLivePage || $[5] !== mode) {
        t3 = mode === "editor" && !isLivePage && intl.formatMessage((0, $586bbeb50503c018$export$a7357cdd1f0b0168).emptyMacroEdit, {
            editIcon: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                label: "edit",
                color: "var(--ds-icon, #292A2E)"
            })
        });
        $[3] = intl;
        $[4] = isLivePage;
        $[5] = mode;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t1
        }, t2, t3);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};



var $f9KPY = parcelRequire("f9KPY");








var $lMGh1 = parcelRequire("lMGh1");

class $6d5b4820d47006ab$var$ExcerptIncludeErrorComponent extends (0, $cozmU.PureComponent) {
    render() {
        const { targetContentTitle: targetContentTitle, intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'inline-block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                borderRadius: 5,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: 668,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 25,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                padding: "var(--ds-space-050, 4px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                paddingLeft: "var(--ds-space-050, 4px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                verticalAlign: 'text-bottom'
            }
        }, intl.formatMessage({
            id: "editor.excerpt.include.macro.error"
        }, {
            0: targetContentTitle
        })));
    }
}
const $6d5b4820d47006ab$export$9959a21ec1aff866 = (0, $kSwu1.injectIntl)($6d5b4820d47006ab$var$ExcerptIncludeErrorComponent);


/* eslint-disable check-file/filename-blocklist */ 


const $6818d60359395137$export$9c17ec9416db96e4 = (macroOutput)=>{
    try {
        if (macroOutput) {
            const parsed = JSON.parse(macroOutput);
            if (parsed.version === 1 && parsed.type === 'doc' && parsed.content) return parsed;
        }
    } catch (e) {
    // do nothing in case of parsing error, which would return `undefined`
    }
};
const $6818d60359395137$export$47eae2202f029f6b = (node)=>// The localId fallback is only needed for included-content TOC heading
    // links. Gate it so non-TOC excerpt rendering (including SSR placeholder
    // matching via data-fabric-macro / data-ssr-placeholder) keeps prior
    // behaviour and the macroId is unchanged.
    (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true) ? node?.parameters?.macroMetadata?.macroId?.value || node?.attrs?.parameters?.macroMetadata?.macroId?.value || node?.localId || node?.attrs?.localId : node?.parameters?.macroMetadata?.macroId?.value;
const $6818d60359395137$export$a22f425ed063044b = (node, name)=>node?.parameters?.macroParams?.[name]?.value;
const $6818d60359395137$var$EXTENSION_NODE_TYPES = new Set([
    'extension',
    'inlineExtension',
    'bodiedExtension',
    'multiBodiedExtension'
]);
const $6818d60359395137$var$MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.macro.core';
const $6818d60359395137$var$LEGACY_CONTENT_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $6818d60359395137$var$LEGACY_CONTENT_EXTENSION_KEY = 'legacy-content';
const $6818d60359395137$export$470b2a37ce5145f1 = (adf, sourceContentId)=>{
    if (Array.isArray(adf)) return adf.map((node)=>$6818d60359395137$var$injectParentIdIntoNode(node, sourceContentId));
    return $6818d60359395137$var$injectParentIdIntoNode(adf, sourceContentId);
};
const $6818d60359395137$var$injectParentIdIntoNode = (node, sourceContentId)=>{
    if (!node || typeof node !== 'object') return node;
    let updatedNode = node;
    if (node.type && $6818d60359395137$var$EXTENSION_NODE_TYPES.has(node.type) && node.attrs?.extensionType === $6818d60359395137$var$MACRO_EXTENSION_TYPE && !node.attrs?.parameters?.macroParams?._parentId) updatedNode = {
        ...node,
        attrs: {
            ...node.attrs,
            parameters: {
                ...node.attrs?.parameters,
                macroParams: {
                    ...node.attrs?.parameters?.macroParams,
                    _parentId: {
                        value: sourceContentId
                    }
                }
            }
        }
    };
    const nestedContent = node.attrs?.extensionType === $6818d60359395137$var$LEGACY_CONTENT_EXTENSION_TYPE && node.attrs?.extensionKey === $6818d60359395137$var$LEGACY_CONTENT_EXTENSION_KEY ? node.attrs?.parameters?.nestedContent : undefined;
    if (nestedContent && typeof nestedContent === 'object') updatedNode = {
        ...updatedNode,
        attrs: {
            ...updatedNode.attrs,
            parameters: {
                ...updatedNode.attrs?.parameters,
                nestedContent: $6818d60359395137$export$470b2a37ce5145f1(nestedContent, sourceContentId)
            }
        }
    };
    if (updatedNode.content && Array.isArray(updatedNode.content)) updatedNode = {
        ...updatedNode,
        content: updatedNode.content.map((child)=>$6818d60359395137$var$injectParentIdIntoNode(child, sourceContentId))
    };
    return updatedNode;
};



var $1OGI3 = parcelRequire("1OGI3");

const $a28c11b9954ec4f2$export$358a2d09bf0dde5a = (t0)=>{
    const $ = (0, $bDgLe.c)(84);
    const { contentId: contentId, spaceKey: spaceKey, extensionKey: extensionKey, macroNode: macroNode, mode: mode, RendererWrapper: RendererWrapper, isLegacyRenderer: isLegacyRenderer, isLivePage: isLivePage } = t0;
    const { extensionType: extensionType, parameters: t1, type: type } = macroNode;
    const { macroMetadata: macroMetadata, macroParams: macroParams, macroOutput: macroOutput, mediaToken: mediaToken } = t1;
    let t2;
    if ($[0] !== macroNode) {
        t2 = (0, $5kjCz.getMacroAttributesFromADFNode)(macroNode);
        $[0] = macroNode;
        $[1] = t2;
    } else t2 = $[1];
    const attributes = t2;
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const adfFromMacroOutput = (0, $6818d60359395137$export$9c17ec9416db96e4)(macroOutput)?.content;
    const t3 = extensionKey ?? "";
    let t4;
    if ($[2] !== macroMetadata) {
        t4 = JSON.stringify(macroMetadata);
        $[2] = macroMetadata;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== macroParams) {
        t5 = JSON.stringify(macroParams);
        $[4] = macroParams;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = {
            macroMetadata: t4,
            macroParams: t5
        };
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    const t7 = type ?? "";
    let t8;
    if ($[9] !== extensionType || $[10] !== t3 || $[11] !== t6 || $[12] !== t7) {
        t8 = {
            extensionKey: t3,
            extensionType: extensionType,
            parameters: t6,
            type: t7
        };
        $[9] = extensionType;
        $[10] = t3;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== contentId || $[15] !== t8) {
        t9 = {
            contentId: contentId,
            macroNode: t8
        };
        $[14] = contentId;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    const t10 = !!adfFromMacroOutput;
    let t11;
    if ($[17] !== t10 || $[18] !== t9) {
        t11 = {
            variables: t9,
            skip: t10
        };
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    const { data: data, loading: loading, error: error } = (0, $1OGI3.useExperimentalMacroMetadataQuery)(t11);
    let t12;
    if ($[20] !== macroNode) {
        t12 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "") || "";
        $[20] = macroNode;
        $[21] = t12;
    } else t12 = $[21];
    const targetContentTitle = t12;
    let t13;
    if ($[22] !== macroNode) {
        t13 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "nopanel");
        $[22] = macroNode;
        $[23] = t13;
    } else t13 = $[23];
    const shouldPanelBeDisplayed = t13 !== "true";
    let t14;
    if ($[24] !== macroNode) {
        t14 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "inline");
        $[24] = macroNode;
        $[25] = t14;
    } else t14 = $[25];
    const displayInline = t14 === "true";
    let t15;
    if ($[26] !== macroNode) {
        t15 = (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "name");
        $[26] = macroNode;
        $[27] = t15;
    } else t15 = $[27];
    const excerptName = t15;
    let t16;
    if ($[28] !== macroNode) {
        t16 = (0, $6818d60359395137$export$47eae2202f029f6b)(macroNode);
        $[28] = macroNode;
        $[29] = t16;
    } else t16 = $[29];
    const macroId = t16;
    let t17;
    if ($[30] !== contentId || $[31] !== data?.experimentalMacroMetadata?.contentId || $[32] !== macroNode) {
        t17 = data?.experimentalMacroMetadata?.contentId || (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "_referencedContentId") || (0, $6818d60359395137$export$a22f425ed063044b)(macroNode, "_parentId") || contentId || "";
        $[30] = contentId;
        $[31] = data?.experimentalMacroMetadata?.contentId;
        $[32] = macroNode;
        $[33] = t17;
    } else t17 = $[33];
    const targetContentId = t17;
    const adfString = data?.experimentalMacroMetadata?.payload;
    let t18;
    if ($[34] !== adfString) {
        t18 = adfString ? JSON.parse(adfString) : undefined;
        $[34] = adfString;
        $[35] = t18;
    } else t18 = $[35];
    const parsedAdf = t18;
    const adf = adfFromMacroOutput ?? parsedAdf;
    let t19;
    if ($[36] !== adf || $[37] !== contentId || $[38] !== targetContentId) {
        t19 = adf && targetContentId !== contentId && (0, $9wGTI.fg)("send_parent_id_in_macro_query") ? (0, $6818d60359395137$export$470b2a37ce5145f1)(adf, targetContentId) : adf;
        $[36] = adf;
        $[37] = contentId;
        $[38] = targetContentId;
        $[39] = t19;
    } else t19 = $[39];
    const adfWithParentId = t19;
    let t20;
    if ($[40] !== RendererWrapper || $[41] !== contentId || $[42] !== displayInline || $[43] !== excerptName || $[44] !== extensionKey || $[45] !== isLegacyRenderer || $[46] !== isLivePage || $[47] !== macroId || $[48] !== macroNode || $[49] !== mode || $[50] !== shouldPanelBeDisplayed || $[51] !== spaceKey || $[52] !== targetContentTitle) {
        t20 = {
            RendererWrapper: RendererWrapper,
            extensionKey: extensionKey,
            macroNode: macroNode,
            mode: mode,
            pageId: contentId,
            spaceKey: spaceKey,
            shouldPanelBeDisplayed: shouldPanelBeDisplayed,
            displayInline: displayInline,
            excerptName: excerptName,
            targetContentTitle: targetContentTitle,
            macroId: macroId,
            isLegacyRenderer: isLegacyRenderer,
            isLivePage: isLivePage
        };
        $[40] = RendererWrapper;
        $[41] = contentId;
        $[42] = displayInline;
        $[43] = excerptName;
        $[44] = extensionKey;
        $[45] = isLegacyRenderer;
        $[46] = isLivePage;
        $[47] = macroId;
        $[48] = macroNode;
        $[49] = mode;
        $[50] = shouldPanelBeDisplayed;
        $[51] = spaceKey;
        $[52] = targetContentTitle;
        $[53] = t20;
    } else t20 = $[53];
    const props = t20;
    if (adfFromMacroOutput) {
        let t21;
        if ($[54] !== adfWithParentId || $[55] !== mediaToken || $[56] !== props || $[57] !== renderServerPlaceholder || $[58] !== targetContentId) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5942172932878591$export$1980ed6e948b49ee), {
                ...props,
                adf: adfWithParentId,
                contentId: targetContentId,
                mediaToken: mediaToken,
                renderServerPlaceholder: renderServerPlaceholder
            });
            $[54] = adfWithParentId;
            $[55] = mediaToken;
            $[56] = props;
            $[57] = renderServerPlaceholder;
            $[58] = targetContentId;
            $[59] = t21;
        } else t21 = $[59];
        return t21;
    }
    if (loading) {
        let t21;
        if ($[60] !== shouldPanelBeDisplayed || $[61] !== targetContentTitle) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9KPY.ExcerptIncludeComponentShadow), {
                shouldPanelBeDisplayed: shouldPanelBeDisplayed,
                targetContentTitle: targetContentTitle
            });
            $[60] = shouldPanelBeDisplayed;
            $[61] = targetContentTitle;
            $[62] = t21;
        } else t21 = $[62];
        return t21;
    }
    if (error) {
        let t21;
        if ($[63] !== error || $[64] !== extensionKey) {
            t21 = error || new (0, $422HI.ApolloErrorInterop)({
                errorMessage: `${extensionKey} failed to render because macro metadata payload is empty`
            });
            $[63] = error;
            $[64] = extensionKey;
            $[65] = t21;
        } else t21 = $[65];
        const queryError = t21;
        let t22;
        if ($[66] !== macroNode || $[67] !== mode) {
            t22 = (0, $5kjCz.getExperienceName)(mode, macroNode);
            $[66] = macroNode;
            $[67] = mode;
            $[68] = t22;
        } else t22 = $[68];
        let t23;
        if ($[69] !== attributes || $[70] !== contentId || $[71] !== mode || $[72] !== queryError || $[73] !== t22) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hUS75.MacroExperienceStop), {
                error: queryError,
                mode: mode,
                name: t22,
                attributes: attributes,
                contentId: contentId,
                source: "ExcerptIncludeImpl"
            });
            $[69] = attributes;
            $[70] = contentId;
            $[71] = mode;
            $[72] = queryError;
            $[73] = t22;
            $[74] = t23;
        } else t23 = $[74];
        let t24;
        if ($[75] !== targetContentTitle) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6d5b4820d47006ab$export$9959a21ec1aff866), {
                targetContentTitle: targetContentTitle
            });
            $[75] = targetContentTitle;
            $[76] = t24;
        } else t24 = $[76];
        let t25;
        if ($[77] !== t23 || $[78] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t23, t24);
            $[77] = t23;
            $[78] = t24;
            $[79] = t25;
        } else t25 = $[79];
        return t25;
    }
    let t21;
    if ($[80] !== adfWithParentId || $[81] !== props || $[82] !== targetContentId) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5942172932878591$export$1980ed6e948b49ee), {
            ...props,
            adf: adfWithParentId,
            contentId: targetContentId
        });
        $[80] = adfWithParentId;
        $[81] = props;
        $[82] = targetContentId;
        $[83] = t21;
    } else t21 = $[83];
    return t21;
};


const $c6f28e626bacffe3$export$f31130fd0c7ad090 = (props)=>{
    const $ = (0, $bDgLe.c)(15);
    const { isProviderAvailable: isProviderAvailable, addKey: addKey, hasKey: hasKey, removeKey: removeKey } = (0, $e77954c2fac8bb43$export$3f68eeb1746e8c90)();
    const [circularReferenceDetected, setCircularReferenceDetected] = (0, $cozmU.useState)(undefined);
    const excerptPageTitle = props?.macroNode?.parameters?.macroParams?.[""]?.value;
    const excerptName = props?.macroNode?.parameters?.macroParams?.name?.value ?? "UNDEFINED_EXCERPT_NAME";
    const excerptKeyFromMacroParams = excerptPageTitle !== undefined ? `${excerptPageTitle}-${excerptName}` : undefined;
    let t0;
    let t1;
    if ($[0] !== addKey || $[1] !== excerptKeyFromMacroParams || $[2] !== hasKey || $[3] !== isProviderAvailable || $[4] !== removeKey) {
        t0 = ()=>{
            if (!excerptKeyFromMacroParams || !isProviderAvailable) return;
            let didAdd = false;
            if (hasKey(excerptKeyFromMacroParams)) setCircularReferenceDetected(true);
            else {
                setCircularReferenceDetected(false);
                addKey(excerptKeyFromMacroParams);
                didAdd = true;
            }
            return ()=>{
                if (didAdd) removeKey(excerptKeyFromMacroParams);
            };
        };
        t1 = [
            excerptKeyFromMacroParams,
            isProviderAvailable,
            hasKey,
            addKey,
            removeKey
        ];
        $[0] = addKey;
        $[1] = excerptKeyFromMacroParams;
        $[2] = hasKey;
        $[3] = isProviderAvailable;
        $[4] = removeKey;
        $[5] = t0;
        $[6] = t1;
    } else {
        t0 = $[5];
        t1 = $[6];
    }
    (0, $cozmU.useEffect)(t0, t1);
    if (!isProviderAvailable) {
        let t2;
        if ($[7] !== props) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a28c11b9954ec4f2$export$358a2d09bf0dde5a), props);
            $[7] = props;
            $[8] = t2;
        } else t2 = $[8];
        let t3;
        if ($[9] !== excerptKeyFromMacroParams || $[10] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e77954c2fac8bb43$export$8fbc0efd03a015e), {
                excerptKey: excerptKeyFromMacroParams
            }, t2);
            $[9] = excerptKeyFromMacroParams;
            $[10] = t2;
            $[11] = t3;
        } else t3 = $[11];
        return t3;
    } else {
        if (circularReferenceDetected === undefined) return null;
        else if (circularReferenceDetected) {
            let t2;
            if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0f05f8ec17df934b$export$6990faa355fa7d3), null);
                $[12] = t2;
            } else t2 = $[12];
            return t2;
        } else {
            let t2;
            if ($[13] !== props) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a28c11b9954ec4f2$export$358a2d09bf0dde5a), props);
                $[13] = props;
                $[14] = t2;
            } else t2 = $[14];
            return t2;
        }
    }
};
module.exports["ExcerptInclude"] = $c6f28e626bacffe3$export$f31130fd0c7ad090;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("4JC0x", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $dOBRD.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
    window['__MISSING_DATA_MACROS__'] = window['__MISSING_DATA_MACROS__'] || [];
    window['__MISSING_DATA_MACROS__'].push(macroId);
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}
module.exports["macrosPreloadPerformed"] = $98c2a7811aa5a89d$export$1441f92d09a5c3ee;
module.exports["getPreloadFailedMacros"] = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf;
module.exports["getPreloadFailures"] = $98c2a7811aa5a89d$export$3288a79f0c713f52;
module.exports["getGeneralFailures"] = $98c2a7811aa5a89d$export$34734b475a3fd7b9;
module.exports["markMissingMacroData"] = $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("llqlc", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

function $64e7b9256d090f27$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $64e7b9256d090f27$export$3dea766d36a8935f;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});


//# sourceMappingURL=ExcerptInclude.65fb8e5d.js.map
